import React from 'react';
import {SearchIcon} from "./Support/Icon";
import {addHttpIfNeeded, isValidUrl, stripHttps} from "./Support/Helper"
import {EVENT_FORM_SUBMITTED} from "./Support/Events";

export default class Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            url: this.props.url ?? null,
            urlIsValid: null
        };
        this.onChangeUrl = this.onChangeUrl.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.url !== this.props.url) {
            this.setState({
                url: this.props.url
            });
        }
    }

    onChangeUrl(e) {
        this.setState({
            url: e.target.value
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        const url = addHttpIfNeeded(this.state.url);

        let urlIsValid = false;

        if (isValidUrl(url)) {
            urlIsValid = true;
        }

        this.setState({
            urlIsValid: urlIsValid
        });

        if (!urlIsValid) {
            return;
        }

        let event = new CustomEvent(EVENT_FORM_SUBMITTED, {
            detail: {
                url: url
            }
        });

        document.dispatchEvent(event);
    }

    getInputValidationClassName() {
        if (this.urlIsValid === false) {
            return 'input-invalid';
        }
        else if (this.urlIsValid === true) {
            return 'input-valid';
        }

        return '';
    }

    render() {

        return (
            <div className='scanner-header'>
                <div className='container mx-auto px-3 text-center'>
                    <div className='py-24'>
                        <div className='mb-8'>
                            <h2 className='mb-4 headline'>Ist Google Fonts DSGVO-konform eingebunden?</h2>
                            <h4 className='mb-4 sub-headline'>Jetzt prüfen und Abmahnung verhindern!</h4>
                        </div>
                        <form action='#' onSubmit={this.handleSubmit} aria-label='url-form' noValidate>
                            <div className='grid grid-cols-12 max-w-4xl xl:max-w-4xl m-auto gap-3'>
                                <div className='col-span-12 md:col-span-6 lg:col-span-7 xl:col-span-8'>
                                    <div className='relative'>
                                        <div className='absolute top-0 left-0 w-5 h-full flex items-center ml-4'>
                                            <SearchIcon/>
                                        </div>
                                        <input
                                            onChange={this.onChangeUrl}
                                            defaultValue={stripHttps(this.props.url)}
                                            placeholder={'ihre-domain.de'}
                                            type='url'
                                            autoComplete='on'
                                            className={`h-12 border-white pl-11 border-2 rounded-l-sm rounded-r-sm md:rounded-r-none px-3 py-2 w-full text-gray-600 focus:ring-green focus:border-green ${this.getInputValidationClassName()}`}
                                        />
                                    </div>
                                </div>
                                {this.state.urlIsValid === false && (
                                    <small className='col-span-12 md:order-3 text-red-400 text-left'
                                           aria-label='error-message'>Die eingegebene Domain ist ungültig. Bitte geben
                                        Sie die Adresse Ihrer Website z. B. https://mustermann.de oder
                                        https://www.mustermann.de ein</small>
                                )}
                                <div className='col-span-12 md:col-span-6 lg:col-span-5 xl:col-span-4  md:order-2'>
                                    <button
                                        aria-label='Formular absenden'
                                        type='submit'
                                        className='whitespace-nowrap text-sm button px-3 py-2 rounded-l-sm md:rounded-l-none rounded-r-sm w-full disabled:opacity-95'>
                                        Jetzt Website prüfen
                                    </button>
                                </div>
                                <div className='col-span-12 md:order-4'>
                                    <p className='whitespace-nowrap'>Rechtssichere Website mit eRecht24 Legal Toolbox</p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}
